import React from 'react';
import { trackPixelEvent } from './MetaPixel';
export const CHECKOUT_URL = 'https://ingles-listo.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  note?: string;
  href?: string;
  className?: string;
  size?: 'md' | 'lg';
};
export function CtaButton({
  label = '¡Quiero mi Kit ahora!',
  note,
  href = CHECKOUT_URL,
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  const isLarge = size === 'lg';
  const sizeClasses = isLarge ? 'px-9 py-6 text-xl sm:px-14 sm:py-7 sm:text-3xl' : 'px-7 py-4 text-base sm:text-lg';
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} onClick={() => {
    if (!isInternal) {
      trackPixelEvent('InitiateCheckout', {
        value: 17,
        currency: 'USD'
      });
    }
  }} className={`group inline-flex flex-col items-center justify-center rounded-3xl bg-brand text-center leading-none text-white shadow-[0_8px_0_0_#8f2109] transition-[transform,background-color,box-shadow] duration-200 ease-out hover:-translate-y-1 hover:bg-brand-dark hover:shadow-[0_12px_0_0_#8f2109] active:translate-y-1 active:shadow-[0_4px_0_0_#8f2109] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 ${sizeClasses} ${className}`} data-id="element-46" data-mp="10amxso3zyeva">
      <span className="font-display tracking-[0.01em]" data-id="element-47" data-mp="3jy8l1ya48cgk">{label}</span>
      {note && <span className={`font-sans font-bold uppercase tracking-[0.12em] text-white/85 ${isLarge ? 'mt-3 text-[11px] sm:text-xs' : 'mt-2 text-[10px]'}`} data-id="element-48" data-mp="3ovih3ws0fmdd">
          {note}
        </span>}
    </a>;
}